export default "__VITE_ASSET__BSkNPAVq__"